import './App.css';
import CodeComparator from './CodeComparator';

function App() {
  return (
    <div className="App">
      <CodeComparator />
    </div>
  );
}

export default App;
